/* src/modules/create_tutors/cards/CreateTutorCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, capitalize, isEmpty, toUpper } from 'lodash';
import { loadTexts } from '../../../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Chip,
  Divider,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import { Add, Search } from '@material-ui/icons';
import { Expand } from '../../../../app/components';

import AddCourses from '../../../../app/components/user/AddCourses';

import styles from './styles';

import {
  getOrganization,
  getUniversity,
  getSearchResult,
} from '../../selectors';
import { addTutors } from '../../actions';
import { searchCourses } from '../../../courses/actions';
import { parseCourseString } from '../../../../util';

import frenchPasswordUniversities from '../../french_password_universities';
import mentorshipPasswordOrganizations from '../../mentorship_password_organizations';

const TEXT_KEY = "create_tutors";

class CreateTutorCard extends React.Component {
  state = {
    email: '',
    first: '',
    last: '',
    coursesString: '',
    formattingError: false,
    found: '',
    notFound: '',
    openSelect: false,
    courses: [],
    texts: loadTexts(TEXT_KEY, this.props.locale)
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedUniversity !== this.props.selectedUniversity)
      this.setState({ courses: [], found: '', notFound: '' });
  }

  _onChangeFirst = event => {
    this.setState({ first: event.target.value });
  };

  _onChangeLast = event => {
    this.setState({ last: event.target.value });
  };

  _onChangeEmail = event => {
    this.setState({ email: event.target.value });
  };

  _onChangeCourses = event => {
    this.setState({ coursesString: event.target.value });
  };

  _onPressCreate = async () => {
    const { texts } = this.state;
    const university = this.props.universities.find(
      u => u._id === this.props.selectedUniversity,
    );
    const ssoDomain = get(university, 'ssoEmailDomain');
    const { first, last, email, courses } = this.state;
    // check if email is valid
    if (email) {
      const emailSplit = email.split('@');
      if (emailSplit.length !== 2) {
        alert(texts.alerts.valid_email);
        return;
      }

      if (ssoDomain && emailSplit[1] !== ssoDomain) {
        alert(
          `${texts.alerts.email_format}${ssoDomain}`,
        );
        return;
      }
    }

    try {
      const params = {
        addTutorsInput: [
          {
            first,
            last,
            email,
            courses: courses.map(c => ({ _course: c._id })),
          },
        ],
        password: 'newtutor1',
        organization: this.props.selectedOrganization,
        university: this.props.selectedUniversity,
      };
      if (frenchPasswordUniversities.includes(this.props.selectedUniversity))
        params.password = 'nouveaututeur1';

      if (mentorshipPasswordOrganizations.includes(this.props.selectedOrganization))
        params.password = 'newmentor1';

      await this.props.addTutors(params);
      this.setState({
        first: '',
        last: '',
        email: '',
        courses: [],
        found: '',
        notFound: '',
        coursesString: '',
      });
    } catch (error) {
      console.log(error);
    }
  };

  _onPressSearch = async () => {
    const { coursesString } = this.state;
    const courses = parseCourseString(coursesString);
    if (~courses.indexOf(false)) {
      this.setState({
        formattingError: true,
        found: '',
        notFound: '',
        courses: [],
      });
      return;
    }

    this.setState({ formattingError: false });

    await this.props.searchCourses({
      university: this.props.selectedUniversity,
      input: courses,
    });

    this.setState(this.props.searchedCourses);
  };

  renderInputs(classes) {
    const {
      courses,
      email,
      first,
      last,
      coursesString,
      formattingError,
      texts
    } = this.state;
    const { fields, button_text } = texts;
    const chipStyle = { marginBottom: 8, marginRight: 8 };
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className={classes.deliveryForm}>
          <TextField
            id="email"
            label={fields.email}
            InputLabelProps={{ shrink: true }}
            value={email}
            onChange={this._onChangeEmail}
          />
          <div className={classes.nameFields}>
            <TextField
              id="first"
              label={fields.first}
              style={{ width: '49%' }}
              InputLabelProps={{ shrink: true }}
              value={first}
              onChange={this._onChangeFirst}
            />
            <TextField
              id="last"
              label={fields.last}
              InputLabelProps={{ shrink: true }}
              style={{ width: '49%' }}
              value={last}
              onChange={this._onChangeLast}
            />
          </div>
        </div>
        {/*
        <TextField
          id="courses"
          className={classes.coursesInput}
          label="Courses"
          InputLabelProps={{ shrink: true }}
          value={coursesString}
          onChange={this._onChangeCourses}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  className={classes.adornment}
                  aria-label="Parse Course String"
                  onClick={this._onPressSearch}
                  color="primary"
                  variant="outlined"
                  size="small"
                >
                  <Search className={classes.alarmIcon} />
                  {'Search'}
                </Button>
              </InputAdornment>
            ),
          }}
        />
        {formattingError && (
          <Typography color="secondary">
            {'There were some issues when parsing the courses field'}
          </Typography>
        )}
        */}
        <div style={{ flex: 1, paddingLeft: 8 }}>
          <Button
            color="primary"
            variant="raised"
            onClick={() => this.setState({ openSelect: true })}
            style={{ width: '100%', marginBottom: 8 }}
          >
            {button_text.add_course}
          </Button>
          {courses.map(course => (
            <Chip
              key={course._id}
              size="small"
              label={course.code}
              style={chipStyle}
              onDelete={() =>
                this.setState({
                  courses: courses.filter(c => c._id !== course._id),
                })
              }
            />
          ))}
          <AddCourses
            open={this.state.openSelect}
            onClose={() => this.setState({ openSelect: false })}
            ref={node => (this.addCoursesComponent = node)}
            onSelect={item => {
              if (!courses.find(c => c._id === item._id))
                return this.setState({ courses: [...courses, item] });
              this.setState({
                courses: courses.filter(c => c._id !== item._id),
              });
            }}
            selected={courses}
            selectedUniversity={this.props.selectedUniversity}
          />
        </div>
      </div>
    );
  }

  renderButton(classes) {
    const { email, first, last, courses, texts } = this.state;
    return (
      <Button
        disabled={!(email && first && last && !isEmpty(courses))}
        color="primary"
        variant="raised"
        className={classes.button}
        onClick={this._onPressCreate}
      >
        <Add className={classes.alarmIcon} />
        {texts.button_text.create_tutor}
      </Button>
    );
  }

  renderInfo(name, type) {
    const props = { variant: 'subheading' };
    let text = name;
    if (!name) {
      props.color = 'secondary';
      text = `[NO ${toUpper(type)}]`;
    }
    return <Typography {...props}>{`${capitalize(type)}: ${text}`}</Typography>;
  }

  renderOrganization(classes) {
    const { texts: { fields } } = this.state;
    return this.renderInfo(this.props.selectedOrgName, fields.organization, classes);
  }

  renderUniversity(classes) {
    const { texts: { fields } } = this.state;
    return this.renderInfo(this.props.selectedUniName, fields.institution, classes);
  }

  renderSearchResults() {
    // const { coursesString } = this.state;
    const { found, notFound, texts } = this.state;
    //
    // if (!coursesString) return null;
    const { title: { course_to_add, course_not_found } } = texts;
    return (
      <React.Fragment>
        {found && <Typography>{`${course_to_add} ${found}`}</Typography>}
        {notFound && (
          <Typography color="secondary">{`${course_not_found} ${notFound}`}</Typography>
        )}
      </React.Fragment>
    );
  }

  renderInstructions(classes) {
    const { texts: { instructions: { title, format_title, format, example } } } = this.state;
    return (
      <Expand text={title}>
        <Typography variant="body2" className={classes.instructions}>
          {`${format_title}\n`}
        </Typography>
        <Typography variant="body1" className={classes.instructions}>
          {format}
        </Typography>
        <div style={{ height: 12 }} />
        <Typography variant="body2" className={classes.instructions}>
          {example}
        </Typography>
        <Typography variant="body1" className={classes.instructions}>
          {'MATH|133;COMP|202&250&273'}
        </Typography>
      </Expand>
    );
  }

  render() {
    const { classes } = this.props;
    const { texts: { title } } = this.state;
    return (
      <Paper className={classes.paper}>
        <div style={{ height: 24 }} />
        <Typography variant="title" className={classes.title}>
          {title.create_tutor}
        </Typography>
        <div className={classes.padding} style={{ paddingTop: 0 }}>
          {this.renderOrganization(classes)}
          {this.renderUniversity(classes)}
        </div>
        <Divider />
        {/* this.renderInstructions(classes) */}
        <div className={classes.padding}>
          {this.renderInputs(classes)}
          {this.renderSearchResults(classes)}
          <div className={classes.buttonContainer}>
            {this.renderButton(classes)}
          </div>
        </div>
      </Paper>
    );
  }
}

CreateTutorCard.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  addTutors: PropTypes.func.isRequired,
  selectedOrganization: PropTypes.string.isRequired,
  searchCourses: PropTypes.func.isRequired,
  searchedCourses: PropTypes.object.isRequired,
  selectedOrgName: PropTypes.string.isRequired,
  selectedUniName: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  selectedOrganization: state.auth.selectedOrganization,
  selectedOrgName: getOrganization(state),
  selectedUniversity: state.auth.selectedUniversity,
  selectedUniName: getUniversity(state),
  searchedCourses: getSearchResult(state),
  universities: get(state, 'auth.data.user.universities'),
  locale: state.appState.locale
});

const mapDispatchToProps = dispatch => ({
  addTutors: params => dispatch(addTutors(params)()),
  searchCourses: params => dispatch(searchCourses(params)()),
});

export default compose(
  withStyles(styles, { name: 'CreateTutorCard' }),
  connect(mapStateToProps, mapDispatchToProps),
)(CreateTutorCard);



// WEBPACK FOOTER //
// ./src/modules/create_tutor/cards/CreateTutorCard/index.js